import QuotingServices from "../../services/QuotingServices";
import vm from '@/main.js'
const state = {
    loadingExternal: false,
    externalRequestInspection: null,
    externalProductionReport: null,
    broker: null
};
const getters = {
    externalRequestInspection: state => {
        return state.externalRequestInspection;
    },
    externalProductionReport: state => {
        return state.externalProductionReport;
    },
    loadingExternal: state => {
        return state.loadingExternal;
    },
    broker: state => {
        return state.broker;
    }
};

const actions = {
    external(context) {
        context.commit("showLoadingIndicator");
        const profile = context.rootGetters.userProfile;
        const agencyId= context.rootGetters.agencyId;
        return QuotingServices.external(profile,agencyId)
            .then(response => {
                if (response.data.error == 0) { 
                    state.externalRequestInspection = response.data.data[0];
                    state.externalProductionReport = response.data.data[4];

                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingIndicator");
            });
    },
    getBroker(context){
        return state.broker = context.rootGetters.userProfile.business_name;
    }
};

const mutations = {
    showLoadingIndicator(state) {
        state.loadingExternal = true;
    },
    hideLoadingIndicator(state) {
        state.loadingExternal = false;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};